module.exports = __webpack_public_path__ + "img/1473240228.e45885fc.jpg";